<div class="mat-slider-wrapper" #sliderWrapper>
  <div class="mat-slider-track-wrapper">
    <div class="mat-slider-track-background" [ngStyle]="_getTrackBackgroundStyles()"></div>
    <div class="mat-slider-track-fill" [ngStyle]="_getTrackFillStyles()"></div>
  </div>
  <div class="mat-slider-ticks-container" [ngStyle]="_getTicksContainerStyles()"><div class="mat-slider-ticks" [ngStyle]="_getTicksStyles()"></div></div>
  <div class="mat-slider-thumb-container" [ngStyle]="_getThumbContainerStyles()">
    <div class="mat-slider-focus-ring"></div>
    <div class="mat-slider-thumb"></div>
    <div class="sg-input-slider-input">
      <mat-form-field [color]="color">
        <input matInput type="number" [min]="min" [max]="max" [step]="step" [value]="sgDisplayValue" (keyup)="inputValueChanged($any($event).target.value)" />
        <span matSuffix><ng-content select="[matSuffix]"></ng-content></span>
      </mat-form-field>
    </div>
  </div>
</div>
